import Security from '@/features/termAndPrivacy/pages/Security'

export default Security
